export var getFlexDirection = function getFlexDirection(isUserOnMobile) {
  return isUserOnMobile ? 'column' : undefined;
};